'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Container-module_container__P04Z6{box-sizing:border-box;margin:0 auto;padding:0 .25rem}";
var styles = {"container":"Container-module_container__P04Z6"};
styleInject["default"](css_248z, 'd33b3883-4886-42fe-a952-0dd79144f3a4');

exports["default"] = styles;
